// extracted by mini-css-extract-plugin
export default {"tabs":"ListTabs_tabs__YbWca","button":"ListTabs_button__oln4t"};